import { ServerCategory } from './categoriesList'


export const URL = '/v2/pms/accomodations/:accomId/room_categories/:categoryId/'

export type Req = void

export type Resp = ServerCategory
